<template>
	<span>
		<span v-if="props.type == 'select'">
			<a-select
          ref="userselect"
          :mode="props.mode"
          allowClear
          size="default"
          :open="false"
          :style="{ width: props.showButton ? '90%' : '100%' }"
          v-model:value="currentValue"
          @click="showUserPlusModal"
      >
				<a-select-option v-for="item in selectedList" :value="item.userId" :key="item.userId">
					{{ item.nickname }}
				</a-select-option>
			</a-select>
			<a-button v-if="props.showButton" @click="showUserPlusModal" :style="{ width: props.showButton ? '10%' : '0%' }">
				<template #icon>
					<select-outlined />
				</template>
				<span>选择</span>
			</a-button>
		</span>
		<div v-else class="add-user-wrapper">
			<div class="add-user-icon">
				<a-button shape="round" @click="showUserPlusModal">
					<template #icon>
						<plus-outlined />
					</template>
				</a-button>
			</div>
			<div class="add-user-item" v-for="item in selectedList" :key="item.id">
				<a-avatar size="small">
					<template #icon><UserOutlined /></template>
				</a-avatar>
				<div>{{ item.name }}</div>
				<close-outlined @click="removeSelectedItem(item)" />
			</div>
		</div>
		<user-selector-plus
        ref="userselectorPlus"
        page-url="/sys/user/page"
        org-url="/sys/org/tree"
        :max="max"
        :min="min"
        @onBack="callBack"
    />
	</span>
</template>
<script setup name="GUser">
import {onMounted, ref, watch} from 'vue'
import {remove} from 'lodash-es'
import userSelectorPlusApi from '@/api/components/Selector/userSelectorPlusApi'
// 接收属性
const props = defineProps({
  mode: { type: String, default: 'default' },
  type: { type: String, default: 'select' },
  showButton: { type: Boolean, default: false },
  modelValue: { type: Array, default: () => [] },
  min: { type: Number, default: 1 },
  max: { type: Number, default: 100000 }
})

const currentValue = ref([])

const selectedList = ref([])

const userselectorPlus = ref()

watch(
    () => props.modelValue,
    (newValue) => {
      console.log('newValue', newValue)
      if (selectedList.value.length == 0) {
        // 获取用户信息
        if (newValue && newValue.length > 0) {
          reload(newValue)
        }
      } else if (newValue && newValue[0] == undefined) {
        currentValue.value = []
        selectedList.value = []
      }
    }
)

onMounted(() => {
  if (selectedList.value.length == 0) {
    // 获取机构信息
    if (props.modelValue && props.modelValue.length > 0) {
      reload(props.modelValue)
    }
  }
})

const reload = async (empIds) => {
  const params = []
  if(Array.isArray(empIds)) {
    for (let i = 0; i < empIds.length; i++) {
      params.push({ id: empIds[i] })
    }
  } else {
    params.push({ id: empIds })
  }
  const res = await userSelectorPlusApi.getUsersByUserIds('/sys/user/ids', params)
  console.info("ids",res)
  if (res) {
    res.forEach((item) => {
      currentValue.value.push(item.id)
      selectedList.value.push(item)
      emit(
          'update:label',
          selectedList.value.map((a) => a.name)
      )
    })
  }
}

const showUserPlusModal = () => {
  userselectorPlus.value.showUserPlusModal(selectedList.value)
}

const removeSelectedItem = (record) => {
  remove(selectedList.value, (item) => item.id === record.id)
  remove(currentValue.value, (item) => item === record.id)
  // 只有ID
  userselectorPlus.value.delRecord(record)
  console.log('currentValue.value', currentValue.value)
  emit('update:modelValue', currentValue.value)
  emit(
      'update:label',
      selectedList.value.map((a) => a.name)
  )
  emit('update:data', selectedList)
}

const emit = defineEmits(['update:modelValue', 'update:data', 'update:label', 'click'])

/**
 * 确定
 * @param {*} record
 */
const callBack = (records) => {
  console.log('records', records)
  selectedList.value = []
  currentValue.value = []
  for (let index = 0; index < records.length; index++) {
    const element = {
      userId: records[index].id,
      nickname: records[index].name
    }
    selectedList.value.push(element)
    // 只有ID
    currentValue.value.push(records[index].id)
  }
  emit('update:modelValue', currentValue.value)
  emit(
      'update:label',
      selectedList.value.map((a) => a.nickname)
  )
  emit('update:data', selectedList)
}

defineExpose({})
</script>
<style lang="less" scoped>
.add-user-wrapper {
  display: flex;
  flex-wrap: wrap;
  min-height: 40px;
  padding-left: 5px;
  .add-user-icon {
    display: flex;
    align-items: center;
    width: 40px;
    height: 32px;
    border-radius: 100px;
    border: 1px solid #3370ff;
    justify-content: center;
    margin-right: 8px;
    margin-top: 8px;
    cursor: pointer;
  }
  .add-user-item {
    display: flex;
    align-items: center;
    min-width: 70px;
    max-width: 50%;
    height: 32px;
    background: #eff0f1;
    border-radius: 16px;
    padding: 0 4px;
    margin-right: 8px;
    margin-top: 8px;

    img {
      width: 24px;
      height: 24px;
      border-radius: 12px;
    }
    div {
      padding: 0;
      margin: 0 4px;
      min-width: 28px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    i {
      margin-right: 10px;
      color: #646a73;
      cursor: pointer;
    }
  }
}
.selected-items {
  overflow-y: auto;
  margin: 0 10px 0;
  border: 1px dashed #ccc;
  padding: 4px 4px 0;
  min-height: 34px;
  max-height: 60px;
  .ant-tag {
    margin-bottom: 4px;
  }
}
</style>
